
namespace RioERP.Masters {
    export class WhatsAppTemplateVariableMapColumns {
        static columnsKey = 'Masters.WhatsAppTemplateVariableMap';
    }
}